import { render, staticRenderFns } from "./homeHeader.vue?vue&type=template&id=160f97b1&scoped=true&"
import script from "./homeHeader.vue?vue&type=script&lang=js&"
export * from "./homeHeader.vue?vue&type=script&lang=js&"
import style0 from "./homeHeader.vue?vue&type=style&index=0&id=160f97b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160f97b1",
  null
  
)

export default component.exports